import jwt from '@/auth/jwt/useJwt'

export default function Files() {
  let filesFormData = new FormData()

  const setFilesFormData = (files, type) => {
    files.forEach(file => {
      filesFormData.append('attachments[]', file.url)
    })

    filesFormData.append('type', type)
  }

  const uploadFilesRequest = () => jwt.axiosIns.post('files', filesFormData).then(res => res)

  const uploadFiles = (files, type) => {
    setFilesFormData(files, type)

    return uploadFilesRequest().then(res => {
      filesFormData = new FormData()
      return res
    })
  }

  const deleteFileRequest = id => jwt.axiosIns.delete(`files/${id}`).then(res => res)

  return { uploadFiles, deleteFileRequest }
}
